/**
 *  _ __|_  __|___ o| 
 * (_)| |_)(_)|_| |||<

 * Orbotnik Customisation of shared modules
 * 
 * This module contains a custom implementation of an error handling function for AJAX requests made within ProjectA. 
 * It is designed to be imported and used by other modules in the project when a request doesn't return a successful response.
 * 
 * Functionality:
 * - fnAJAXOutcomeErrorCallback : This function takes as input an AJAXOutcome object 
 *   and returns a boolean indicating the success or failure of the request. If the ajax_status in the AJAXOutcome object 
 *   is 401, it performs user logout, prompts the user with a message about initiating reload due to the 401 status, and 
 *   based on user's response, it either reloads the page or does nothing. For all other error statuses, it logs the error 
 *   and the entire AJAXOutcome object to the console for debugging purposes.
 *
 * This module provides a way for ProjectA to have a custom error handling strategy that differs from other projects.
 * It allows for flexibility and separation of concerns, as the error handling logic is isolated in this module.
 */

import { useErrorContext } from "../contexts/ErrorContext"
import { AJAXOutcome } from "./sputnikapi"
import { Severity } from '../services/redux/consoleSlice';

/**
 * Define the base URL to access the SputnikAPI.  If in the same path, use '/', if a local var, then reference it, if hardcode, then state it.
 */
export const SputnikAPIBaseURL = '/' //`${import.meta.env.VITE_ENVIRONMENT_SPUTNIKAPI}/`



/**
 * Handles AJAX request errors for Orbotnik.
 *
 * This function takes an AJAXOutcome object as input and checks the `ajax_status` field. If the status code
 * is 401, it performs user logout, prompts the user with a message about initiating a page reload due to 
 * the 401 status, and depending on the user's response, either reloads the page or does nothing. For any 
 * other status codes, it logs an error message and the entire AJAXOutcome object to the console for debugging 
 * purposes. The function always returns false to indicate that the AJAX request was unsuccessful.
 *
 * @param {AJAXOutcome} ptReturn - The AJAXOutcome object from the AJAX request.
 * @returns {boolean} - Always returns false, indicating that the AJAX request was unsuccessful.
 */
export function fnAJAXOutcomeErrorCallback(ptReturn:AJAXOutcome): boolean {
    console.log("Some other error occured on the server - do we need to reset anything?")
    console.log(ptReturn)
    return false
};

